<div  class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>

        <p>{{'FRONT_USER.ERRORS_MESSAGES.LinkInValid' | translate}}</p>
        <hr>
        <p>{{'FRONT_USER.RESET_PASSWORD_FORM.GET_ANOTHER_CODE' | translate }} <a routerLink="/resetpassword">
          {{ 'FRONT_USER.RESET_PASSWORD_FORM.RESET_PASSWORD' | translate}}</a>  
        </p>
    </div>
</div>